import styled from "styled-components";

export const StyledSection = styled.section`
  padding: 20px 16px;
`;

export const StyledUl = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

